<template>
    <b-container>
        <template v-if="$options.components['advertisement-loading']">
            <advertisement-loading v-if="isLoading" />
        </template>
        <div v-if="!isLoading">
        <b-row>
            <b-col class="my-4">
                <div class="main-banner">
                    <img :src="(marketBannerImage.icon && marketBannerImage.icon.fileUrl) || ''
                        " alt="Healthcare Market Banner" />
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col
                v-for="product in productList"
                :key="product.category"
                md="4"
            >
            <div>
                <b-card
                  :title="product.hospitalName"
                  :img-src="product.backgroundImage"
                  img-alt="Image"
                  img-top
                  tag="article"
                  class="mb-2"
                >
                  <b-card-text class="mb-1">
                    <b-icon icon="geo-alt-fill" class="mr-1"></b-icon>Haldwani, Uttarakhand
                </b-card-text>

                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <span>
                            <b-icon class="custom-icon" icon="geo-alt-fill"></b-icon>

                            <b-icon class="custom-icon" icon="geo-alt-fill"></b-icon>
                            <small class="ml-1">5 KM</small>
                        </span>
                    </div>
                    <div>
                        <template>
                            <div>
                              <b-form-rating
                                class="review-star"
                                v-model="starValue"
                                readonly
                                variant="warning"
                                inline
                                no-border
                              ></b-form-rating>
                            </div>
                          </template>
                          <!-- <span>{{starValue}}</span> -->
                    </div>
                  </div>
                
                  <div class="d-flex justify-content-center mt-1">
                    <b-button 
                        variant="custom" 
                        @click="onClickBooking"
                        class="custom-button">Direct Booking
                    </b-button>
                  </div>
                  
                </b-card>
              </div>

            </b-col>
            <div>
                <b-container>
                  <template v-if="$options.components['advertisement-bottom-banner']">
                    <advertisement-bottom-banner />
                  </template>
                </b-container>
              </div>
        </b-row>
    </div>
    </b-container>
</template>

<script>
import { mapState } from "vuex";
export default {
    data() {
        return {
            isLoading: false,
            starValue: 4.5,
            productList: [
                { hospitalName: "Hospital Name", backgroundImage: "https://picsum.photos/600/300/?image=24" },
                { hospitalName: "Hospital Name", backgroundImage: "https://picsum.photos/600/300/?image=23" },
                { hospitalName: "Hospital Name", backgroundImage: "https://picsum.photos/600/300/?image=22" },
                { hospitalName: "Hospital Name", backgroundImage: "https://picsum.photos/600/300/?image=22" },
                { hospitalName: "Hospital Name", backgroundImage: "https://picsum.photos/600/300/?image=21" },
                { hospitalName: "Hospital Name", backgroundImage: "https://picsum.photos/600/300/?image=19" },
                { hospitalName: "Hospital Name", backgroundImage: "https://picsum.photos/600/300/?image=18" },
            ],
        };
    },

    computed: {
        ...mapState({
            marketBannerImage: (state) => state.healthCare.marketBanner,
        }),
    },

    methods: {
        onClickBooking(){
            this.$router.push({
                name: 'hospital-details',
                params: {  },
            });
        },
    },

    async mounted() {
        this.isLoading = true;
        let payload = {
            city: "GHATAL",
            placement: "MARKET_TOP",
            market: this.$route.params.marketid,
        };
        await this.$store.dispatch("healthCare/fetchMarketBanner", payload);

        this.isLoading = false;
    },
};
</script>

<style scoped>
.main-banner {
    border-radius: 8px;
    margin-bottom: 20px;
}

.main-banner img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
}
.card-title {
    font-size: 15px;
    font-weight: 600;
    line-height: 17.58px;
}
.card-img, .card-img-top {
    width: 225px;
    height: 161px;
}
.card {
    height: 300px;
    width: 225px;
}
.btn:not(:disabled):not(.disabled) {
    width: 134px;
    height: 25px;
    padding: 3px 0 5px 0;
    font-size: 14px;
}
p{
    font-size: 12px;
}
.custom-button {
    background-color: #0038AB !important;
    color: white !important;
}
.custom-icon{
    font-size: 11px;
}
.review-star {
    padding: 0px;
    font-size: 14px;
  }
</style>